import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  container: {
    width: '100%',
    alignItems: 'center',
    gap: theme.spacing[4],
    paddingVertical: theme.spacing[9],
  },
  resendButton: {
    width: '75%',
  },
}));
